import styled from 'styled-components'

export const StyledWishlistButtonContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
`
